import React, { useState, useEffect, useRef } from 'react';
import { DialogContentText } from '@material-ui/core';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { Document, Page, pdfjs } from 'react-pdf';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  MenuItem,
  TextField,
  DialogActions,
  Checkbox,
  FormControlLabel,
  FormLabel,
  FormHelperText,
  Typography,
  Grid,
  FormControl,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Select from 'react-select';
import PDFSingleViewer from '../../../../components/PDFSingleViewer';
import ImgSingleViewer from '../../../../components/ImgSingleViewer';
import {
  makeS3BlobsRenderable,
  fileSelectHandler,
} from '../../../../util/fileHandling';
import Button from '../../../../components/Button';
import ProviderSearchBar from '../../../../components/ProviderSearchBar';
import TimeSelect from '../../../../components/TimeSelect';
import PatientSearchBar from '../../../../components/PatientSearchBar';
import * as api from '../../../../services/api/admin';
import * as authApi from '../../../../services/api/auth';
import DateSelect from '../../../../components/DateSelect';
import NoticeDialog from '../../../../components/DialogModals/NoticeDialog';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { STATES_LIST } from '../../../../constants';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${
  pdfjs.version
}/pdf.worker.js`;
const options = {
  cMapUrl: 'cmaps/',
  cMapPacked: true,
};

function CreateAppointmentModal(props) {
  const {
    open,
    onSubmit,
    onClose,
    overBookAlert,
    // openDuplicateApptAlert,
    // closeDuplicateApptAlert,
    closeAlert,
    classes: {
      modal,
      selectInput,
      modalContent,
      input,
      dialogFooter,
      warning,
      previewImg,            
      button,
      btnCenter,
    },
  } = props;

  const [currentUser, setCurrentUser] = useState({});
  const [currentPatient, setCurrentPatient] = useState({});
  const [selectedProvider, setSelectedProvider] = useState({});
  const [specialties, setSpecialties] = useState([]);
  const [currentSpecialty, setCurrentSpecialty] = useState(null);
  const [tenancyList, setTenancyList] = useState([]);
  const [currentTenancyId, setCurrentTenancyId] = useState('');
  const [formInfoConfirmed, setFormInfoConfirmed] = useState(false);
  const [portalNotes, setPortalNotes] = useState('');
  const [date, setDate] = useState(
    moment()
      .tz('America/New_York')
      .format('MM/DD/YYYY')
  );
  const [time, setTime] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});
  const [fromProvider, setFromProvider] = useState({});
  const [conciergeMode, setConcierge] = useState(false);

  const [images, setImages] = useState([]);
  const [openPDFModal, setOpenPDFModal] = useState(false);
  const [openImgModal, setOpenImgModal] = useState(false);
  const [currentPDF, setCurrentPDF] = useState([]);
  const [currentImg, setCurrentImg] = useState('');
  const [imagePreview, setImagePreview] = React.useState(true);
  const [popNotice, setPopNotice] = useState('');
  const [insurancePlans, setInsurancePlans] = useState([]);
  const [insurancePlanId, setInsurancePlanId] = useState(null);
  const [insuranceName, setInsuranceName] = useState('');
  const [insuranceId, setInsuranceId] = useState('');
  const [payerId, setPayerId] = useState('');
  const [groupNumber, setGroupNumber] = useState('');
  const [addressLine1, setAddressLine1] = useState('');
  const [addressLine2, setAddressLine2] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [zipcode, setZipcode] = useState('');
  const [addressConfirmed, setAddressConfirmed] = useState(false);
  const [insuranceConfirmed, setInsuranceConfirmed] = useState(false);
  const myRef = useRef(null);

  // These are insurances that has no group number.
  const insuranceWithoutGroupNumber = ['729d4056-09e9-4b3a-a37b-8a236bb154ab', '74a91228-6503-4851-922d-d4e23bc402ff', '1d1dae88-1d16-4e3b-a63d-a32e74a88e0a']

  useEffect(() => {
    (async () => {
      const response = await api.fetchTebraInsurancesList();
      setInsurancePlans(response.data || []);
    })();
  }, []);

  // loading appropriate tenancies when current provider is updated
  useEffect(() => {
    (async () => {
      setCurrentUser(await authApi.fetchCurrentUser());
    })();
    if (selectedProvider.id) {
      (async () => {
        if (
          selectedProvider.fullTitle === 'Qwell Concierge Recommendations' ||
          selectedProvider.fullTitle ===
            'Qwell Lexington Medical Associates Recommendations'
        ) {
          setConcierge(true);
          if (!specialties.length) {
            const fetchedSpecialties = await api.fetchSpecialties();
            setSpecialties(fetchedSpecialties);
          }
        } else {
          setConcierge(false);
          if (currentSpecialty) {
            setCurrentSpecialty(null);
          }
        }
        const tenancies = await api.fetchTenancies(selectedProvider.id);
        setTenancyList(
          tenancies.map(tenancy => ({
            value: tenancy.id,
            label: tenancy.location,
          }))
        );
        setCurrentTenancyId(tenancies[0].id);
      })();
    }
  }, [selectedProvider]);

  const chooseFromList = objType => chosenObj => {
    if (objType === 'patient') {
      setCurrentPatient(chosenObj || {});

      const insuranceData = {
        insurancePlanId: chosenObj?.insurancePlanId || null,
        insuranceName: chosenObj?.insuranceName || '',
        insuranceId: chosenObj?.insuranceId || '',
        payerId: chosenObj?.payerId || '',
        groupNumber: chosenObj?.groupNumber || '',
      };

      const addressData = {
        addressLine1: chosenObj?.addressLine1 || '',
        addressLine2: chosenObj?.addressLine2 || '',
        city: chosenObj?.city || '',
        state: chosenObj?.state || '',
        zipcode: chosenObj?.zipcode || '',
      };

      setInsurancePlanId(insuranceData.insurancePlanId);
      setInsuranceName(insuranceData.insuranceName);
      setInsuranceId(insuranceData.insuranceId);
      setPayerId(insuranceData.payerId);
      setGroupNumber(insuranceData.groupNumber);

      setAddressLine1(addressData.addressLine1);
      setAddressLine2(addressData.addressLine2);
      setCity(addressData.city);
      setState((addressData.state || '').toUpperCase().slice(0, 2));
      setZipcode(addressData.zipcode);

      setInsuranceConfirmed(false);
      setAddressConfirmed(false);
    }
    if (objType === 'provider') {
      setSelectedProvider(chosenObj || {});
    }
    if (objType === 'tenancy') {
      setCurrentTenancyId(chosenObj.target.value);
    }
    setValidationErrors({ ...validationErrors, [objType]: false });
  };

  const changeDate = date => {
    if (date) {
      setDate(date.tz('America/New_York').format('MM/DD/YYYY'));
      setValidationErrors({ ...validationErrors, date: false });
    }
  };

  const changeTime = event => {
    const nextTime = moment(event.target.value);
    if (nextTime) {
      setTime(nextTime.toISOString());
      setValidationErrors({ ...validationErrors, time: false });
    }
  };

  const callSetImage = event => {
    setImages([]);
    fileSelectHandler(
      event.target.files,
      inputPicCallBack,
      ['jpg', 'jpeg', 'pdf'],
      1048576 // 1048576 bytes = 1MBl
    );
  };

  const handleOpenImg = link => {
    setOpenImgModal(true);
    setCurrentImg(link);
  };
  const handleOpenPDF = link => {
    setOpenPDFModal(true);
    setCurrentPDF(link);
  };

  // const inputPicCallBack = fileObject => {
  //   const [fileObjectOrStatusCode] = fileObject;
  //   if (fileObjectOrStatusCode < 0 && fileObjectOrStatusCode >= -2) {
  //     const notice = (fileObjectOrStatusCode === -1)? 'Max file size is 2MB' : 'Please use a valid file to upload';
  //     setPopNotice(notice);
  //   } else {
  //     setImages([
  //       ...[],
  //       fileObjectOrStatusCode,
  //     ])
  //   }
  // }

  const inputPicCallBack = fileObject => {
    setImages(fileObject);
    fileObject.map(fileObjectOrStatusCode => {
      if (fileObjectOrStatusCode < 0 && fileObjectOrStatusCode >= -2) {
        const notice =
          fileObjectOrStatusCode === -1
            ? 'Max file size is 2MB'
            : 'Please use a valid file to upload';
        setPopNotice(notice);
        myRef.current.value = null;
        setImages([]);
      }
    });
  };

  const validate = () => {
    let valid = true;
    let nextState = {};
    if (!conciergeMode && !formInfoConfirmed) {
      nextState.confirmed = 'Required';
      valid = false;
      if (!zipcode) {
        valid = false;
        nextState.zipcode = 'Required';
      }
      if (!addressLine1?.trim()) {
        valid = false;
        nextState.addressLine1 = 'Required';
      }
      if (!city?.trim()) {
        valid = false;
        nextState.city = 'Required';
      }
      if (!state?.trim()) {
        valid = false;
        nextState.state = 'Required';
      } else if (!state.match(/^[A-Z]{2}$/)) {
        valid = false;
        nextState.state = 'Must be a valid 2-letter state code';
      }
      if (!insurancePlanId) {
        valid = false;
        nextState.insurancePlanId = 'Required';
      }
      if (!insuranceId) {
        valid = false;
        nextState.insuranceId = 'Required';
      }
      // For Medicare insurance group number is not required.
      if (!groupNumber && !insuranceWithoutGroupNumber?.includes(insurancePlanId)) {
        valid = false;
        nextState.groupNumber = 'Required';
      }
      if (!addressConfirmed) {
        valid = false;
        nextState.addressConfirmed = 'Please confirm the address information is correct';
      }
      if (!insuranceConfirmed) {
        valid = false;
        nextState.insuranceConfirmed = 'Please confirm the insurance information is correct';
      }
    } else {
      if (!currentPatient.id) {
        valid = false;
        nextState.patient = 'Required';
      }
      if (!selectedProvider) {
        valid = false;
        nextState.provider = 'Required';
      }
      if (!currentTenancyId) {
        valid = false;
        nextState.tenancy = 'Required';
      }
      if (!date) {
        valid = false;
        nextState.date = 'Required';
      }
      if (!time) {
        valid = false;
        nextState.time = 'Required';
      }
      if (!portalNotes) {
        valid = false;
        nextState.portalNotes = 'Required';
      }
      if (!zipcode) {
        valid = false;
        nextState.zipcode = 'Required';
      }
      if (!addressLine1?.trim()) {
        valid = false;
        nextState.addressLine1 = 'Required';
      }
      if (!city?.trim()) {
        valid = false;
        nextState.city = 'Required';
      }
      if (!state?.trim()) {
        valid = false;
        nextState.state = 'Required';
      } else if (!state.match(/^[A-Z]{2}$/)) {
        valid = false;
        nextState.state = 'Must be a valid 2-letter state code';
      }
      if (!insurancePlanId) {
        valid = false;
        nextState.insurancePlanId = 'Required';
      }
      if (!insuranceId) {
        valid = false;
        nextState.insuranceId = 'Required';
      }

      // For Medicare insurance group number is not required.
      if (!groupNumber?.trim() && !insuranceWithoutGroupNumber?.includes(insurancePlanId)) {
        valid = false;
        nextState.groupNumber = 'Required';
      }
      if (!addressConfirmed) {
        valid = false;
        nextState.addressConfirmed = 'Please confirm the address information is correct';
      }
      if (!insuranceConfirmed) {
        valid = false;
        nextState.insuranceConfirmed = 'Please confirm the insurance information is correct';
      }
    }
    setValidationErrors(nextState);
    return valid;
  };

  const save = async () => {
    const apptTime = moment(
      moment(date).format('MM/DD/YYYY') + ' ' + moment(time).format('HH:mm')
    ).toISOString();
    const isApptBooked = await onSubmit({
      fromProviderUserId: currentUser.isAdministrator
        ? fromProvider.userId
        : currentUser.isProvider
        ? currentUser.id
        : null,
      tenancyId: currentTenancyId,
      patientEmail: currentPatient.email,
      patientInsurancePlanId: insurancePlanId,
      patientInsuranceName: insuranceName,
      patientInsuranceId: insuranceId,
      patientPayerId: payerId,
      patientGroupNumber: groupNumber,
      patientAddressLine1: addressLine1,
      patientAddressLine2: addressLine2,
      patientCity: city,
      patientState: state,
      patientZipcode: zipcode,
      providerId: selectedProvider.id,
      time: apptTime,
      attachments: images.map(i => i.dataUrl),
      portalNotes: currentSpecialty
        ? `specialty: ${currentSpecialty.label}\n` + portalNotes
        : portalNotes,
    });

    // reset state
    if(isApptBooked){
    setCurrentPatient({});
    setSelectedProvider({});
    setConcierge(false);
    setCurrentSpecialty(null);
    setSpecialties([]);
    setCurrentTenancyId('');
    setDate(null);
    setTime(null);
    setPortalNotes('');
    setFormInfoConfirmed(false);
    setTenancyList([]);
    setImages([]);
    setInsurancePlanId(null);
    setInsuranceName('');
    setInsuranceId('');
    setPayerId('');
    setGroupNumber('');
    setAddressLine1('');
    setAddressLine2('');
    setCity('');
    setState('');
    setZipcode('');
    setAddressConfirmed(false);
    setInsuranceConfirmed(false);
    onClose();
    }
  };

  // const closeModel = ()=>{
  //   setCurrentPatient({});
  //   setSelectedProvider({});
  //   setConcierge(false);
  //   setCurrentSpecialty(null);
  //   setSpecialties([]);
  //   setCurrentTenancyId('');
  //   setDate(null);
  //   setTime(null);
  //   setPortalNotes('');
  //   setFormInfoConfirmed(false);
  //   setTenancyList([]);
  //   onClose();
  // }

  return (
    <Dialog fullWidth open={open} onClose={onClose} classes={{ paper: modal }}>
      <DialogTitle>
        <span style={{ fontSize: '1.5em', fontWeight: 'bold' }}>
          Create a new appointment
        </span>
      </DialogTitle>

      <DialogContent classes={{ root: modalContent }}>
        <PatientSearchBar
          onSelect={chooseFromList('patient')}
          errorMessage={validationErrors.patient}
        />

        <FormControl component="fieldset">
          <FormControlLabel
            control={
              <Checkbox
                checked={addressConfirmed}
                onChange={event => {
                  setAddressConfirmed(event.target.checked);

                  setValidationErrors(prev => ({
                    ...prev,
                    addressConfirmed: '',
                  }));
                }}
                value="primary"
              />
            }
            label="I confirm that the address information listed below is correct"
          />

          {validationErrors.addressConfirmed && (
            <FormHelperText error>
              {validationErrors.addressConfirmed}
            </FormHelperText>
          )}
        </FormControl>

        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              name="addressLine1"
              variant="outlined"
              label="Address Line 1"
              value={addressLine1 || ''}
              onChange={(event) => {
                setAddressLine1(event.target.value);

                setValidationErrors(prev => ({
                  ...prev,
                  addressLine1: '',
                }));
              }}
              className={input}
            />
            {validationErrors.addressLine1 && (
              <Typography className={warning}>Required</Typography>
            )}
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              name="addressLine2"
              variant="outlined"
              label="Address Line 2"
              value={addressLine2 || ''}
              onChange={(event) => setAddressLine2(event.target.value)}
              className={input}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              name="city"
              variant="outlined"
              label="City"
              value={city || ''}
              onChange={(event) => {
                setCity(event.target.value);

                setValidationErrors(prev => ({
                  ...prev,
                  city: '',
                }));
              }}
              className={input}
            />
            {validationErrors.city && (
              <Typography className={warning}>Required</Typography>
            )}
          </Grid>

          <Grid item xs={12} md={6}>
            <Autocomplete
              options={STATES_LIST}
              getOptionLabel={option =>
                option ? `${option.code} - ${option.name}` : ''
              }
              value={STATES_LIST.find(option => option.code === state) || null}
              onChange={(_, value) => {
                setState(value?.code || '');

                setValidationErrors(prev => ({
                  ...prev,
                  state: '',
                }));
              }}
              renderInput={params => (
                <TextField
                  {...params}
                  fullWidth
                  name="state"
                  variant="outlined"
                  label="State"
                  className={input}
                />
              )}
            />
            {validationErrors.state && (
              <Typography className={warning}>{validationErrors.state}</Typography>
            )}
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              name="zipcode"
              variant="outlined"
              label="Zipcode"
              value={zipcode || ''}
              onChange={(event) => {
                setZipcode(event.target.value);

                setValidationErrors(prev => ({
                  ...prev,
                  zipcode: '',
                }));
              }}
              className={input}
            />
            {validationErrors.zipcode && (
              <Typography className={warning}>Required</Typography>
            )}
          </Grid>
        </Grid>

        <FormControl component="fieldset">
          <FormControlLabel
            control={
              <Checkbox
                checked={insuranceConfirmed}
                onChange={event => {
                  setInsuranceConfirmed(event.target.checked);

                  setValidationErrors(prev => ({
                    ...prev,
                    insuranceConfirmed: '',
                  }));
                }}
                value="primary"
              />
            }
            label="I confirm that the insurance information listed below is correct"
          />

          {validationErrors.insuranceConfirmed && (
            <FormHelperText error>
              {validationErrors.insuranceConfirmed}
            </FormHelperText>
          )}
        </FormControl>

        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <Autocomplete
              options={insurancePlans}
              getOptionLabel={option =>
                option ? `${option.companyName} - ${option.planName} (${option.payerId})` : ''
              }
              filterOptions={(options, { inputValue }) => {
                const searchValue = inputValue.toLowerCase();

                return options.filter(
                  option =>
                    option.companyName?.toLowerCase().includes(searchValue) ||
                    option.planName?.toLowerCase().includes(searchValue) ||
                    option.payerId?.toLowerCase().includes(searchValue)
                );
              }}
              value={
                insurancePlans.find(item => item.id === insurancePlanId) || null
              }
              onChange={(event, newValue) => {
                setInsuranceName(newValue?.planName || '');
                setInsurancePlanId(newValue?.id || null);
                setPayerId(newValue?.payerId || '');

                setValidationErrors(prev => ({
                  ...prev,
                  insurancePlanId: '',
                }));
              }}
              renderInput={params => (
                <>
                  <TextField
                    {...params}
                    fullWidth
                    variant="outlined"
                    label="Insurance Name / Payer ID"
                    className={input}
                  />
                  {validationErrors.insurancePlanId && (
                    <Typography className={warning}>Required</Typography>
                  )}
                </>
              )}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              InputProps={{
                readOnly: true,
                disabled: true
              }}
              name="payerId"
              variant="outlined"
              label="Payer ID"
              value={payerId || ''}
              onChange={(event) => setPayerId(event.target.value)}
              className={input}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              name="insuranceId"
              variant="outlined"
              label="Insurance ID"
              value={insuranceId || ''}
              onChange={(event) => {
                setInsuranceId(event.target.value);

                setValidationErrors(prev => ({
                  ...prev,
                  insuranceId: '',
                }));
              }}
              className={input}
            />
            {validationErrors.insuranceId && (
              <Typography className={warning}>Required</Typography>
            )}
          </Grid>
        </Grid>

        { !insuranceWithoutGroupNumber?.includes(insurancePlanId) && <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              name="groupNumber"
              variant="outlined"
              label="Group Number"
              value={groupNumber || ''}
              onChange={(event) => {
                setGroupNumber(event.target.value);

                setValidationErrors(prev => ({
                  ...prev,
                  groupNumber: '',
                }));
              }}
              className={input}
            />
            {validationErrors.groupNumber && (
              <Typography className={warning}>Required</Typography>
            )}
          </Grid>
        </Grid>}

        <ProviderSearchBar
          clearable={false}
          label="For Provider"
          name="provider"
          placeholder="Search for a provider..."
          onSelect={chooseFromList('provider')}
          className={selectInput}
          errorMessage={validationErrors.provider}
        />
        {conciergeMode && (
          <Select
            fullWidth
            isSearchable
            isClearable
            aria-label="Specialty"
            placeholder="Specialty"
            value={currentSpecialty}
            onChange={setCurrentSpecialty}
            options={[
              ...specialties.map((specialty) => ({
                value: specialty.shortName,
                label: specialty.name,
              })),
            ]}
            styles={{
              menu: (base) => ({
                ...base,
                zIndex: '999',
              }),
              menuList: (base) => ({
                ...base,
                zIndex: '999',
              }),
            }}
            className={input}
          />
        )}
        {currentUser.isAdministrator && (
          <ProviderSearchBar
            clearable={false}
            label="On Behalf Of (Provider)"
            name="fromProvider"
            placeholder="Search for a provider..."
            practiceId="currentUsersPracticeId"
            onSelect={(provider) => {
              setValidationErrors({ ...validationErrors, fromProvider: false });
              setFromProvider(provider);
            }}
            errorMessage={validationErrors.fromProvider}
            className={selectInput}
          />
        )}

        <TextField
          disabled={
            !selectedProvider || conciergeMode || tenancyList.length < 2
          }
          fullWidth
          variant="outlined"
          label="Location"
          name="tenancy"
          select
          value={currentTenancyId}
          onChange={chooseFromList('tenancy')}
          error={validationErrors.tenancy}
          helperText={validationErrors.tenancy}
          className={selectInput}
        >
          {tenancyList.map((tenancy) => (
            <MenuItem key={`menu-${tenancy.value}`} value={tenancy.value}>
              {tenancy.label}
            </MenuItem>
          ))}
        </TextField>

        <DateSelect
          fullWidth
          variant="outlined"
          label="Date"
          format="MM/DD/YYYY"
          disablePast={currentUser && currentUser.admin ? false : true}
          placeholder="MM/DD/YYYY ex. 01/01/2001"
          value={moment(date).tz('America/New_York')}
          onChange={changeDate}
          error={validationErrors.date}
          helperText={validationErrors.date}
          className={input}
        />

        <TimeSelect
          fullWidth
          label="Time"
          time={time}
          onChange={changeTime}
          error={validationErrors.time}
          helperText={validationErrors.time}
          className={input}
        />

        <Dialog
          open={overBookAlert}
          onClose={closeAlert}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              An appointment has already been booked for this slot. Please
              choose some other available slot.
            </DialogContentText>
            <div className={btnCenter}>
              <Button
                onClick={closeAlert}
                variant="contained"
                color="primary"
                className={button}
              >
                Ok
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        {/* Restrict dupliacte appointments for the same day */}
        {/* <Dialog
          open={openDuplicateApptAlert}
          onClose={closeDuplicateApptAlert}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            An appointment has already been booked for this patient on the given date. Please return to schedule and select another day to book appointment.
            </DialogContentText>
            <div className={btnCenter}>
              <Button
                onClick={closeDuplicateApptAlert}
                variant="contained"
                color="primary"
                className={button}
              >
                Ok
              </Button>
            </div>
          </DialogContent>
        </Dialog>
*/}
        {/* <div style={{ width: '100%', textAlign: 'center' }}>
          <CircularProgress size="90px" />
        </div> */}
        <TextField
          fullWidth
          multiline
          rows="5"
          variant="outlined"
          label="Notes/Portal-Reason"
          name="portalNotes"
          value={portalNotes}
          error={validationErrors.portalNotes}
          helperText={validationErrors.portalNotes}
          className={input}
          onChange={(event) => setPortalNotes(event.target.value)}
        />
        {/* Added file attachment */}
        <FormLabel component="legend">Add attachments</FormLabel>
        <input
          type="file"
          ref={myRef}
          multiple
          onChange={(event) => callSetImage(event)}
        />

        {images && images.length > 0 ? (
          <div>{images.length} images attached</div>
        ) : (
          images.map((image, index) =>
            image?.fileType === 'pdf' ? (
              <>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => handleOpenPDF(image.dataUrl)}
                >
                  Click to Preview
                </Button>

                {/* <Document file={image.dataUrl} options={options} className={previewImg}>
                    <Page pageNumber={1} />
                  </Document> */}

                <PDFSingleViewer
                  openPDFModal={openPDFModal}
                  currentPDF={currentPDF}
                  onClose={() => setOpenPDFModal(false)}
                />
              </>
            ) : (
              <Grid container item xs={12}>
                <Grid item xs={12}>
                  <Button
                    disabled={!imagePreview}
                    color="primary"
                    variant="contained"
                    onClick={() => handleOpenImg(image.dataUrl)}
                  >
                    Click to Preview
                  </Button>
                  <a
                    className="popup-download-btn"
                    target="_blank"
                    href={image && image.dataUrl}
                    download
                  >
                    Download
                  </a>
                </Grid>

                {/* <img src={ image && image.dataUrl} key={`picture-${index}`} onError={()=>setImagePreview(false)} alt="To see full report, please download the file" className={previewImg} /> */}
                <ImgSingleViewer
                  openImgModal={openImgModal}
                  currentImg={currentImg}
                  onClose={() => setOpenImgModal(false)}
                />
              </Grid>
            )
          )
        )}
        {popNotice && (
          <NoticeDialog
            open={popNotice}
            onOkClick={() => setPopNotice('')}
            noticeTitle="Notice"
            message={popNotice}
          />
        )}

        {!conciergeMode && (
          <FormControlLabel
            control={
              <Checkbox
                checked={formInfoConfirmed}
                onChange={() => {
                  setFormInfoConfirmed(!formInfoConfirmed);
                  setValidationErrors({
                    ...validationErrors,
                    confirmed: formInfoConfirmed ? 'Required' : false,
                  });
                }}
                value="primary"
                inputProps={{ 'aria-label': 'primary checkbox' }}
              />
            }
            label={`I have confirmed with ${
              selectedProvider.fullTitle
                ? selectedProvider.fullTitle
                : 'this provider'
            } that I am booking this appointment.`}
          />
        )}
        {validationErrors.confirmed && (
          <Typography className={warning}>Required</Typography>
        )}
      </DialogContent>
      <DialogActions className={dialogFooter}>
        <Button onClick={onClose} variant="outlined" color="primary">
          Back
        </Button>

        <Button
          variant="contained"
          color="primary"
          onClick={save}
          onClickValidation={validate}
          disabledDuringOnClick={true}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

CreateAppointmentModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

const styles = () => ({
  modal: {
    maxHeight: '700px',
  },
  selectInput: {
    marginTop: '0.5em',
    marginBottom: '1em',
  },
  modalContent: {
    overflow: 'visible',
  },
  input: {
    margin: '0.5em 0',
  },
  dialogFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    color: '#ADADAD',
  },
  warning: {
    color: '#e25141',
    fontSize: '12px',
  },
  previewImg: {
    maxWidth: 300,
    maxHeight: 300,
  },
  button: {
    width: '100px',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '0px',
    marginBottom: '15px',
  },
  btnCenter: {
    display: 'flex',
    alignItems: 'center'

  }
});

export default withStyles(styles)(CreateAppointmentModal);
